<!-- <p>stepper-save works!</p> -->
<div class="whiteWrap m-auto">
    <div class="wrap_body TabModule">
        <mat-tab-group animationDuration="0ms"  (selectedTabChange)="onTabChange($event)" [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="Listing Details">
                <div class="tab-body mt-0"></div>
            </mat-tab>
            <mat-tab label="Photos">
                <div class="tab-body mt-0"></div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>